import { postApiRequest } from 'api';

import { AdditionalMark, PostAssignmentMark } from './';

export const createTeacherMarks = (params: PostAssignmentMark[]): Promise<AdditionalMark[]> => {
    return postApiRequest('/teacher-mark/bulk-create/', params);
};
